/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Annotated_ResumeInputs */

const en_annotated_resume = /** @type {(inputs: Annotated_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annotated Resume`)
};

const de_annotated_resume = /** @type {(inputs: Annotated_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annotierter Lebenslauf`)
};

/**
* | output |
* | --- |
* | "Annotated Resume" |
*
* @param {Annotated_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const annotated_resume = /** @type {((inputs?: Annotated_ResumeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Annotated_ResumeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_annotated_resume(inputs)
	return en_annotated_resume(inputs)
});